import React, { useEffect, useState } from 'react';
import { Alert, Button, ListGroup, Spinner } from 'react-bootstrap';
import { readContract, writeContract } from '@wagmi/core';
import bountyContractABI from '../contracts/tgetherConsensusBounty.json';
import postConsensusABI from '../contracts/tgetherPostConsensus.json';
import BountyCreationModal from './FormModals/CreateBountyModal.tsx'; // Import the bounty creation modal
import { formatEther } from 'viem';
import * as config from '../config.tsx';
import { useNavigate } from 'react-router-dom';

interface Bounty {
    bountyAmount: string;
    bountyCreator: string;
    bountyPaid: boolean;
}

function ConsensusBounties({ value }: { value: string }) {
    const [bounties, setBounties] = useState<Bounty[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>('');
    const [showModal, setShowModal] = useState<boolean>(false); // Control bounty modal visibility
    const [postId, setPostId] = useState<any>(null);
    useEffect(() => {
        fetchBounties();
    }, [value]);

    const navigate = useNavigate();

    const fetchBounties = async () => {
        try {
            setLoading(true);
            setError('');

            // Fetch bounty IDs for the given post ID (value)
            const bountyIds = await readContract(config.config, {
                abi: bountyContractABI.abi,
                address: process.env.REACT_APP_CONSENSUS_BOUNTY_CONTRACT_ADDRESS as `0x${string}`,
                functionName: 'GetPostSubmissionBounties',
                args: [value],
            }) as string[];

            const bountyDetails = await Promise.all(
                bountyIds.map(async (bountyId: string) => {
                    const bounty = await readContract(config.config, {
                        abi: bountyContractABI.abi,
                        address: process.env.REACT_APP_CONSENSUS_BOUNTY_CONTRACT_ADDRESS as `0x${string}`,
                        functionName: 'bounties',
                        args: [bountyId],
                    }) as Bounty;
                
                    const bountyAmountInWei =  BigInt(Number(bounty[0]).toString())

                    return {
                        bountyAmount: formatEther(bountyAmountInWei), // Convert Wei to ETH
                        bountyCreator: bounty[1],
                        bountyPaid: bounty[2],
                    };
                })
            );

            const PostId = await readContract(config.config, {
                abi: postConsensusABI.abi,
                address: process.env.REACT_APP_POSTS_CONSENSUS_CONTRACT_ADDRESS as `0x${string}`,
                functionName: 'CommunitySubmissionToPost',
                args: [value],
            }) as any;
            
            console.log(PostId)
            setPostId(PostId.toString());

            setBounties(bountyDetails);
            setLoading(false);
        } catch (error) {
    
            console.error('Error fetching bounties:', error);
            setError('Failed to fetch bounties. Please try again.');
            setLoading(false);
        }
    };

    const handleCreateBounty = () => {
        setShowModal(true); // Show the bounty creation modal when the button is clicked
    };

    const handleCloseModal = () => {
        setShowModal(false); // Hide the modal
    };
    const handleReviewIdClick = () => {
        navigate(`/search-results?type=Post&value=${postId.toString()}`);
      };
    

    return (
        <div>
            {/* Warning banner */}
            <Alert variant="warning">
                Bounties are currently in alpha. By creating bounties you understand there is risk of non payment as we move this feature to its final form.
            </Alert>

            {/* Display bounties */}
            <h4>Bounties for Post ConsensusId: {value}</h4>
            {postId && <p onClick={handleReviewIdClick} style={{textDecoration:"underline", color:"lightblue"}}> PostId: {postId.toString()}</p>}

            {loading && <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
            </Spinner>}

            {error && <Alert variant="danger">{error}</Alert>}

            {!loading && bounties.length === 0 && <Alert variant="info">No bounties found for this post.</Alert>}

            {!loading && bounties.length > 0 && (
                <ListGroup>
                    {bounties.map((bounty, index) => (
                        <ListGroup.Item key={index}>
                            <strong>Bounty Creator:</strong> {bounty.bountyCreator} <br />
                            <strong>Bounty Amount:</strong> {bounty.bountyAmount} ETH <br />
                            <strong>Bounty Paid:</strong> {bounty.bountyPaid ? 'Yes' : 'No'}
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            )}

            {/* Submit new bounty button */}
            <Button variant="primary" className="mt-3" onClick={handleCreateBounty}>
                Submit New Bounty
            </Button>

            {/* Modal for creating a new bounty */}
            <BountyCreationModal
                show={showModal}
                handleClose={handleCloseModal}
                postId={value}
            />
        </div>
    );
}

export default ConsensusBounties;
